import { axios } from '@/services/axios';

const getServiceCategories = async () => {
    const res = await axios.get('/ServiceCategories');
    return res.data;
};

export default getServiceCategories;
